const DEFAULT_CURRENCY_OPTIONS = {decimals: 0};

export interface CurrencyOptions {
    decimals?: number;
}

export function getCurrencySymbolFrom(currencyCode: string): string {
    const symbol = new Intl.NumberFormat('en', formatOptions(currencyCode, DEFAULT_CURRENCY_OPTIONS))
        .formatToParts(1)
        .find((x) => x.type === 'currency');
    if (symbol === undefined) {
        return '';
    }
    return symbol?.value;
}

export function formatAmount(
    locale: string | undefined,
    currencyCode: string,
    amount: number,
    currencyOptions: CurrencyOptions = DEFAULT_CURRENCY_OPTIONS,
): string {
    try {
        return new Intl.NumberFormat(getLocale(locale), formatOptions(currencyCode, currencyOptions)).format(amount);
    } catch {
        return `${formatAmountWithoutSymbol(locale, amount, currencyOptions)} ${currencyCode}`;
    }
}

export function formatAmountWithoutSymbol(
    locale: string | undefined,
    amount: number,
    currencyOptions: CurrencyOptions = DEFAULT_CURRENCY_OPTIONS,
): string {
    return new Intl.NumberFormat(getLocale(locale), formatOptions(undefined, currencyOptions)).format(amount);
}

function formatOptions(currencyCode: string | undefined, currencyOptions: CurrencyOptions): any {
    if (currencyCode !== undefined) {
        return {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: currencyOptions.decimals,
            maximumFractionDigits: currencyOptions.decimals,
        };
    }

    return {};
}

function getLocale(locale: string | undefined): string {
    if (locale === undefined) {
        return 'en';
    }
    return locale;
}
